import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogService } from '../../shared/services/dialog.service';

/** AuthLayout (001–011): panel héroe a la izquierda y formulario a la derecha. */
@Component({
  selector: 'app-auth-layout',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './auth.layout.html',
  styleUrl: './auth.layout.scss',
})
export class AuthLayout {
  private dialog = inject(DialogService);
  readonly year = new Date().getFullYear();

  legal(doc: 'terms' | 'privacy', e: Event): void {
    e.preventDefault();
    this.dialog.legal(doc);
  }
}
